import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiClient from '../api/client';
import './Auth.css';

export default function Payment() {
  const { appointmentId, courseId } = useParams();

  const sourceType = useMemo(
    () => (courseId ? 'course' : 'appointment'),
    [courseId]
  );
  const sourceId = courseId || appointmentId;

  const [method, setMethod] = useState('paypal');
  const [amount, setAmount] = useState('');
  const [currency, setCurrency] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const isCourse = sourceType === 'course';
  const purchaseLabel = isCourse ? 'Course enrolment' : 'Counselling appointment';

  async function payWithPaypal() {
    setBusy(true);
    setError('');
    setStatus('');

    try {
      const res = await apiClient.post('/payments/paypal/create-order', {
        sourceType,
        sourceId,
      });

      setAmount(res.data.amount);
      setCurrency(res.data.currency);

      const approveLink = res.data.order.links?.find(
        (link) => link.rel === 'approve'
      );

      if (res.data.conversionNote) {
        setStatus(res.data.conversionNote);
      }

      if (approveLink) {
        setTimeout(
          () => {
            window.location.href = approveLink.href;
          },
          res.data.conversionNote ? 1800 : 0
        );
      } else if (!res.data.conversionNote) {
        setStatus('Order created. Complete approval in PayPal.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          'PayPal payment could not be started.'
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1>Complete Payment</h1>

        <p className="auth-subtitle">
          {purchaseLabel}
        </p>

        {amount && currency && (
          <p className="auth-subtitle">
            Amount due: <strong>{currency} {amount}</strong>
          </p>
        )}

        {error && <div className="alert alert-error">{error}</div>}
        {status && <div className="alert alert-success">{status}</div>}

        <div
          className="dashboard-tabs"
          style={{ justifyContent: 'center' }}
        >
          <button
            className={`dashboard-tab ${
              method === 'paypal' ? 'active' : ''
            }`}
            onClick={() => setMethod('paypal')}
          >
            PayPal / Card
          </button>

          <button
            className={`dashboard-tab ${
              method === 'mpesa' ? 'active' : ''
            }`}
            onClick={() => setMethod('mpesa')}
          >
            M-Pesa
          </button>
        </div>

        {method === 'paypal' ? (
          <div>
            <p style={{ fontSize: 14.5, lineHeight: 1.7, marginBottom: 16 }}>
              Pay securely with PayPal or a supported card. The amount is
              confirmed by Global Mind Wellness Centre when the payment is
              started.
            </p>

            <button
              className="btn btn-primary"
              onClick={payWithPaypal}
              disabled={busy}
            >
              {busy ? 'Redirecting…' : 'Pay with PayPal'}
            </button>
          </div>
        ) : (
          <div style={{ textAlign: 'left' }}>
            <div
              className="alert alert-info"
              style={{ marginBottom: 16 }}
            >
              <strong>M-Pesa Manual Payment</strong>
            </div>

            <p style={{ fontSize: 14.5, lineHeight: 1.7, marginBottom: 12 }}>
              To pay via M-Pesa, follow these steps:
            </p>

            <ol
              style={{
                fontSize: 14,
                lineHeight: 1.8,
                paddingLeft: 20,
                marginBottom: 16,
              }}
            >
              <li>Go to <strong>M-Pesa</strong> on your phone</li>
              <li>Select <strong>Lipa na M-Pesa</strong></li>
              <li>Select <strong>Buy Goods and Services</strong></li>
              <li>Enter the Till Number below</li>
              <li>
                Enter the amount communicated by Global Mind Wellness Centre
              </li>
              <li>Enter your name as the account reference</li>
              <li>Confirm and complete the payment</li>
            </ol>

            <div
              style={{
                background: 'var(--color-paper, #f7f7f5)',
                borderRadius: 8,
                padding: '12px 16px',
                marginBottom: 16,
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: 13,
                  color: 'var(--color-text-soft, #666)',
                }}
              >
                M-Pesa Till Number
              </p>

              <p
                style={{
                  margin: '4px 0 0',
                  fontSize: 20,
                  fontWeight: 700,
                  letterSpacing: 1,
                }}
              >
                1591263
              </p>
            </div>

            <p
              style={{
                fontSize: 13,
                color: 'var(--color-text-soft, #666)',
                lineHeight: 1.6,
              }}
            >
              After sending payment, our team will confirm receipt and{' '}
              {isCourse
                ? 'activate your course enrolment.'
                : 'activate your appointment.'}{' '}
              You can also send the M-Pesa confirmation screenshot via
              WhatsApp to the same number.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
